<div
  class="gpd-filter"
  [class.gpd-filter-icon-only]="iconOnly"
  [class.gpd-filter-active]="isActive()"
  #filterTarget
  (click)="togglePopover()"
>
  @if (iconOnly) {
  <app-svg-icon icon="filter" [size]="24" [strokeWidth]="1" [color]="isActive() ? 'var(--color-white)' : undefined"></app-svg-icon>
  } @else {
  <div class="filter-text">{{text}}</div>
  }
  @if (multiple && filterCount() > 0 && (activeWhenNotEmpty || options().length !== value().length)) {
  <div class="filter-count" [class.filter-count-icon-only]="iconOnly">{{filterCount()}}</div>
  }
  @if (!iconOnly) {
  <app-svg-icon icon="chevron-down" [size]="20" [color]="isActive() ? 'var(--color-white)' : undefined"></app-svg-icon>
  }
</div>

<dx-popover
  #popover
  [target]="filterTarget"
  [visible]="popoverVisible()"
  (visibleChange)="popoverVisible.set($event)"
  [position]="{ my: 'left top', at: 'left bottom', offset: '0 4' }"
  [showTitle]="false"
  [width]="270"
  [maxHeight]="'50vh'"
  [wrapperAttr]="{class: 'gpd-popover'}"
>
  <div class="gpd-filter-popover">
    <div class="filter-popover-header">
      <div class="filter-popup-title"><span i18n="@@filter">Filter</span> {{text}}</div>
      <div class="filter-popover-search" *ngIf="!disableSearch">
        <dx-text-box class="gpd-input" [(value)]="searchTerm" valueChangeEvent="input" mode="search" i18n-placeholder="@@search" placeholder="Search"></dx-text-box>
      </div>
    </div>
    <div class="filter-popover-body">
      <!--
        Single-select gets radios. Checkboxes promise "tick any combination", and these options
        exclude each other: ticking one silently unticks the other, and the ticked one refuses
        to untick. Radios say that up front.
      -->
      @if (!multiple) {
      <dx-radio-group
        class="gpd-input filter-radio-group"
        [items]="filteredOptions()"
        [displayExpr]="labelExpr"
        [valueExpr]="valueExpr"
        [value]="value()[0]"
        (onValueChanged)="onRadioSelectionChanged($event)"
      ></dx-radio-group>
      } @else {
      <div class="filter-item" *ngIf="options().length > 0 && searchTerm() === '' && !disableAll">
        <dx-check-box
          class="gpd-input"
          [value]="options().length === value().length"
          (onValueChanged)="toggleAll($event, options().length !== value().length)"
        ></dx-check-box>
        <div class="filter-item-label" i18n="@@all" (click)="toggleAll($event, options().length !== value().length)">
          All
        </div>
      </div>
      <div class="filter-item" [class.filter-item-has-subtitle]="subtitleExpr" *ngFor="let item of filteredOptions()">
        <dx-check-box
          class="gpd-input"
          [value]="isSelected(item)"
          [readOnly]="isReadOnly(item)"
          (onValueChanged)="onOptionSelectionChanged($event, item)"
        ></dx-check-box>
        <div class="filter-item-label" (click)="onOptionSelectionChanged($event, item)">
          {{item[labelExpr]}}
          <div class="filter-item-subtitle" *ngIf="subtitleExpr && item[subtitleExpr]">{{item[subtitleExpr]}}</div>
        </div>
      </div>
      }
      <div class="filter-item" *ngIf="options().length === 0">
        <div class="filter-item-label" i18n="@@noResults">No results</div>
      </div>
    </div>
    <div class="filter-popover-footer" [style.display]="isActive() ? 'flex' : 'none'">
      <app-gpd-button type="text" i18n-text="@@resetFilters" text="Reset Filters" (onClick)="clear()"></app-gpd-button>
    </div>
  </div>
</dx-popover>
